var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { ToastStackProvider } from "./toastStackContext";
var ToastStackStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"])));
var ToastStackToastsStyle = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  .bn-toaststack-toasts {\n    position: fixed;\n    width: 100%;\n    bottom: 25px;\n    text-align: center;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    .bn-toast {\n      margin: 5px 0;\n    }\n  }\n"], ["\n  .bn-toaststack-toasts {\n    position: fixed;\n    width: 100%;\n    bottom: 25px;\n    text-align: center;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    .bn-toast {\n      margin: 5px 0;\n    }\n  }\n"])));
var ToastStack = function (_a) {
    var children = _a.children;
    // We need to re-render the componet when the html element changes in order
    // to pass it to the provider.  Using a state variable causes us to rerender when
    // the state changes.
    var _b = __read(React.useState(null), 2), toastStackElement = _b[0], setToastStackElement = _b[1];
    var toastContainer = createPortal(React.createElement(ToastStackToastsStyle, null,
        React.createElement("div", { ref: function (element) { return setToastStackElement(element); }, className: "bn-toaststack-toasts" })), document.body);
    return (React.createElement(ToastStackStyle, { className: "bn-toaststack" },
        React.createElement(ToastStackProvider, { value: toastStackElement },
            children,
            toastContainer)));
};
export default ToastStack;
var templateObject_1, templateObject_2;
//# sourceMappingURL=ToastStack.js.map